    (function() {
        document.addEventListener('contextmenu', function(event) {
            event.preventDefault();
            return false;
        });

        document.addEventListener('copy', function(event) {
            event.preventDefault();
            return false;
        });


        document.addEventListener('cut', function(event) {
            event.preventDefault();
            return false;
        });

        document.addEventListener('dragstart', function(event) {
            event.preventDefault();
            return false;
        });

        document.addEventListener('keydown', function(event) {
            if ((event.ctrlKey || event.metaKey) && (event.key === 'a' || event.key === 'A')) {
                event.preventDefault();
                return false;
            }
            if ((event.ctrlKey || event.metaKey) && (event.key === 'c' || event.key === 'C')) {
                event.preventDefault();
                return false;
            }
            if ((event.ctrlKey || event.metaKey) && (event.key === 'x' || event.key === 'X')) {
                event.preventDefault();
                return false;
            }
        });
        const style = document.createElement('style');
        style.textContent = `
            * {
                -webkit-touch-callout: none; 
                -webkit-tap-highlight-color: transparent;
            }
        `;
        document.head.appendChild(style);

        document.addEventListener('selectstart', function(event) {
            event.preventDefault();
            return false;
        });

    })();